import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/assets/icon/icon-font-size.svg'
import _imports_1 from '../../public/assets/images/grass-white.svg'
import _imports_2 from '../../public/assets/images/logo-blue.svg'


const _withScopeId = n => (_pushScopeId("data-v-1f38c982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-container-col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image-font-size",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "grass-white",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_4 = {
  key: 0,
  src: _imports_2,
  style: {"max-width":"500px","margin-left":"auto","margin-right":"auto"},
  alt: ""
}

import { withDefaults } from "vue";
import { IonBackButton, IonButton, IonButtons, IonHeader, IonToolbar } from "@ionic/vue";
import { chevronBackOutline } from "ionicons/icons"
import { useStore } from "@/stores/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomHeader',
  props: {
    hasBackButton: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { hasBackButton: boolean }



const store = useStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonHeader), {
      style: {"position":"relative"},
      class: "ion-no-border flex-container-row"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), {
          style: {"position":"absolute"},
          class: "ion-padding-top",
          color: "transparent"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                (__props.hasBackButton)
                  ? (_openBlock(), _createBlock(_unref(IonBackButton), {
                      key: 0,
                      class: "back-button",
                      text: "",
                      defaultHref: "../home",
                      icon: _unref(chevronBackOutline),
                      color: "light"
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButtons), {
              style: {"padding-right":"10px"},
              slot: "end"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  class: "text-size-button",
                  shape: "round",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).changeFontSize()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _renderSlot(_ctx.$slots, "default"),
        _hoisted_3
      ]),
      _: 3
    }),
    (!__props.hasBackButton)
      ? (_openBlock(), _createElementBlock("img", _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})